import * as React from 'react'
import { Pressable, View } from 'react-native'
import currency from 'currency.js'
import Modal from 'react-native-modal'
import { Card, Stat } from '@components/Card'
import { useProfile } from '@features/profile/hooks/useProfile'
import { useGoal } from '../hooks/useGoals'
import { EditGoalScreen } from '../screens/EditGoalScreen'
import { LoadingCard } from './LoadingCard'
import { MetricCard } from './MetricCard'
import { SetANeedGoalButton } from './SetANeedGoal'
import styles from './styles'

type State = {
  isOpen: boolean
}

const enum actionTypes {
  toggle = 'TOGGLE',
  open = 'OPEN',
  close = 'CLOSE',
}

type Action = {
  type: actionTypes
}

function toggleReducer(state: State, action: Action): State {
  switch (action.type) {
    case actionTypes.toggle: {
      return { isOpen: !state.isOpen }
    }
    case actionTypes.open: {
      return { isOpen: true }
    }
    case actionTypes.close: {
      return { isOpen: false }
    }
    default: {
      throw new Error(`Unhandled type: ${action.type}`)
    }
  }
}

function useToggle({ reducer = toggleReducer } = {}) {
  const [{ isOpen }, dispatch] = React.useReducer(reducer, {
    isOpen: false,
  })

  const toggle = () => dispatch({ type: actionTypes.toggle })
  const setOpen = () => dispatch({ type: actionTypes.open })
  const setClosed = () => dispatch({ type: actionTypes.close })

  return { isOpen, toggle, setOpen, setClosed }
}

export function UserImpact() {
  const profile = useProfile()
  const { goal, _goalQuery } = useGoal()

  const totalNeedsMet = profile?.needs_met_stats?.all_time || 0

  const totalDollarValue = profile?.needs_met_stats?.all_time_value || 0

  const { isOpen, setOpen, setClosed } = useToggle()

  return (
    <View>
      <Card type="profile" disabled>
        <View style={styles.row}>
          <Stat
            type="profile"
            stat={`${totalNeedsMet}`}
            label="Total Needs Met"
          />
          <Stat
            type="profile"
            stat={new currency(totalDollarValue).format()}
            label="Total Dollar Value"
          />
        </View>

        {_goalQuery.isLoading ? (
          <LoadingCard />
        ) : _goalQuery.data ? (
          <Pressable onPress={setOpen}>
            <MetricCard />
          </Pressable>
        ) : (
          <Pressable onPress={setOpen}>
            <SetANeedGoalButton />
          </Pressable>
        )}
      </Card>
      <Modal isVisible={isOpen} onBackdropPress={setClosed}>
        <EditGoalScreen
          initial={{
            targetValue: goal?.targetValue,
            period: goal?.period,
          }}
          notifyDone={setClosed}
        />
      </Modal>
    </View>
  )
}
